import DashBoardNav from '@/layout/DashBoardNav'

export default [{
  path: '/apidados',
  component: DashBoardNav,
  children: [{
    path: '/apidados',
    component: () => import('@/components/home/apidados.vue')
  },
  ]
}]
